import { useEffect, useState } from 'react';
import { useLocationQuery } from '@hooks';

const InitEditAlert = ({
  allAlerts,
  setVisible,
  setEditAlert,
}) => {
  const query = useLocationQuery();
  const aid = query.get('editAlert');
  const [editAlertId, setEditAlertId] = useState(0);

  useEffect(() => {
    if (aid) {
      setEditAlertId(parseInt(aid, 10));
    }
  }, [setEditAlertId, aid]);

  useEffect(() => {
    if (!editAlertId || !allAlerts) {
      return;
    }
    const editAlert = allAlerts.find(a => a.id === editAlertId);
    if (editAlert) {
      setEditAlert(editAlert);
      setVisible(true);
      setEditAlertId(0);
    }
  }, [editAlertId, allAlerts.length, setEditAlert, setVisible, setEditAlertId]);
};

export default InitEditAlert;
